module.exports = __webpack_public_path__ + "img/banner-5.7553cb50.jpg";